import { supabase, isSupabaseConfigured } from "./supabase";

// Actual email sending happens server-side in netlify/functions/send-lead-
// emails.js via Resend — RESEND_API_KEY is a private key that must never
// ship in the browser bundle, so this only ever calls the function
// endpoint, never the Resend SDK directly.
const SEND_EMAILS_ENDPOINT = "/.netlify/functions/send-lead-emails";

/**
 * Saves a lead against the given book, then best-effort emails the lead
 * their download/read links and notifies the admin. Returns the read/pdf
 * URLs regardless of whether the email actually sent, since the lead is
 * already saved at that point.
 */
export async function submitLead(book, { firstName, lastName, email, phone }) {
  if (!isSupabaseConfigured()) {
    return { error: new Error("Supabase not configured") };
  }

  const readUrl = `${window.location.origin}/books/${book.slug}/read`;

  const { data: lead, error: insertError } = await supabase
    .from("leads")
    .insert({
      book_id: book.id,
      book_slug: book.slug,
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
    })
    .select()
    .single();

  if (insertError) {
    return { error: insertError };
  }

  let emailed = false;
  try {
    const res = await fetch(SEND_EMAILS_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        phone,
        bookTitle: book.title,
        readUrl,
        pdfUrl: book.pdf_url,
      }),
    });
    emailed = res.ok;
    if (!res.ok) {
      console.error("Failed to send lead email:", await res.text());
    }
  } catch (err) {
    console.error("Failed to send lead email:", err);
  }

  if (emailed) {
    await supabase.from("leads").update({ emailed: true }).eq("id", lead.id);
  }

  return { data: { pdfUrl: book.pdf_url, readUrl }, error: null };
}

export async function fetchLeads() {
  if (!isSupabaseConfigured()) {
    return { data: null, error: new Error("Supabase not configured") };
  }
  const { data, error } = await supabase
    .from("leads")
    .select("*")
    .order("created_at", { ascending: false });
  return { data, error };
}
